import { useInfiniteQuery } from '@tanstack/react-query'
import { getListLocation, getListProperty, getListPropertyCompany } from "./api"

export const useGetListLocation = ({ params, options = {} }) => {
  return useInfiniteQuery({
    queryKey: ['get-list-location', params],
    queryFn: ({ pageParam = 1 }) => getListLocation({ ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      return !!lastPage?.data?.data?.length ? allPages.length + 1 : undefined;
    },
    ...options
  })
}

export const useGetListProperties = ({ params, options = {} }) => {
  return useInfiniteQuery({
    queryKey: ['get-list-properties', params],
    queryFn: ({ pageParam = 1 }) => getListProperty({ ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      return !!lastPage?.data?.data?.length ? allPages.length + 1 : undefined;
    },
    ...options
  })
}

export const useGetListPropertiesCompany = ({ params, slug, options = {} }) => {
  return useInfiniteQuery({
    queryKey: ['get-list-properties-company', params],
    queryFn: ({ pageParam = 1 }) => getListPropertyCompany({ ...params, page: pageParam }, slug),
    getNextPageParam: (lastPage, allPages) => {
      return !!lastPage?.data?.data?.length ? allPages.length + 1 : undefined;
    },
    ...options
  })
}
